export class Transmission {
    constructor(
        public Id: number = null,
        public Name: string = null,
        public UserId: number = null,
        public PartnerId: number = null,
        public State: number = null,
        public CustomerId: number = null,
        public CommissionId: number = null,
        public CreatedAt: Date = null,
        public UpdatedAt: Date = null,
    ) {
    }

    public Clone(override: TransmissionAttributes = {}): Transmission {
        const attr = {...this, ...override};
        return Object.assign(new Transmission(), attr);
    }
}

export function TransmissionFromBackend(res: any): Transmission {
    return new Transmission(
        res.id,
        res.name,
        res.user_id,
        res.partner_id,
        res.state,
        res.customer_id,
        res.commission_id,
        res.created_at,
        res.updated_at,
    );
}

export interface TransmissionAttributes {
    Id?: number;
    Name?: string;
    UserId?: number;
    PartnerId?: number;
    State?: number;
    CustomerId?: number;
    CommissionId?: number;
    CreatedAt?: Date;
    UpdatedAt?: Date;
}
